// pricing_features — vertical ARIA tablist for a pricing solution's features.
// Below 1024px the tablist is hidden and every panel is shown (see pricing-tabs.sass).
import { Controller } from '@hotwired/stimulus'

import { trackEvent } from 'api/index'

export default class extends Controller {
  static targets = ['tab', 'panel']
  static values = { solution: String }

  connect() {
    this.current = 0
  }

  activate(event) {
    this.#show(this.tabTargets.indexOf(event.currentTarget))
  }

  nav(event) {
    const tabs = this.tabTargets
    const i = tabs.indexOf(event.currentTarget)
    const next = {
      ArrowUp: (i - 1 + tabs.length) % tabs.length,
      ArrowDown: (i + 1) % tabs.length,
      Home: 0,
      End: tabs.length - 1
    }[event.key]
    if (next === undefined) return

    event.preventDefault()
    this.#show(next)
    tabs[next].focus()
  }

  #show(index) {
    if (index === this.current) return
    this.current = index

    this.tabTargets.forEach((tab, i) => {
      tab.setAttribute('aria-selected', String(i === index))
      tab.tabIndex = i === index ? 0 : -1
    })
    this.panelTargets.forEach((panel, i) => {
      panel.hidden = i !== index
    })

    trackEvent('Marketing:Pricing:Benefit selected', {
      solution: this.solutionValue,
      benefit: this.tabTargets[index].textContent.trim(),
      position: index + 1
    })
  }
}
